import { StudentQuotaHours } from './../../../../admin/model/student-quota-hours.model';
import {Pagination} from '../pagination.model';

export class StudentQuotaHoursPage extends Pagination {
  content: StudentQuotaHours[] = [];
}
